import React from 'react'
import Content from './Content'
import Headerr from './Headerr';
import TeamSection from './TeamSection'
import { toast } from "react-toastify";
const Home1 = () => {
  
  return (
    <>
    <div>
     {/* <Headerr/> */}
     <Content/>  
     {/* <TeamSection /> */}
    </div>
    </>
  )
}

export default Home1
